import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { RadioQuestionModel } from '../../../viewmodels/policy-item.model';
import { TicketMachinesCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ticket-machines-policy',
  templateUrl: './ticket-machines.component.html',
})
export class TicketMachinesComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = TicketMachinesCopy;

  haveTicketMachines = new RadioQuestionModel();
  cancelUphold = new RadioQuestionModel();
  machineMethod = new RadioQuestionModel();
  faultyMachinePolicy = new RadioQuestionModel();
  acceptFaultyMachine = new RadioQuestionModel();
  refund = new RadioQuestionModel();
  other = new RadioQuestionModel();
  whatPolicy = new RadioQuestionModel();
  expiredTicket = new RadioQuestionModel();

  complaintDays = '';
  faultyMachine = '';
  fewDays = '';
  safeguard = '';

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setHaveTicketMachinesQuestion();
    this.setCancelUpholdQuestion();
    this.setMachineMethodQuestion();
    this.setFaultyMachinePolicyQuestion();
    this.setAcceptFaultyMachineQuestion();
    this.setRefundQuestion();
    this.setOtherQuestion();
    this.setWhatPolicyQuestion();
    this.setExpiredTicketQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setHaveTicketMachinesQuestion() {
    this.haveTicketMachines.data = {
      title: this.textCopy.haveTicketMachinesTitle,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'no', value: 'n' },
      ],
    };
  }
  onHaveTicketMachinesSelected(answerValue) {
    this.haveTicketMachines.valueSelected = answerValue;
  }

  setCancelUpholdQuestion() {
    this.cancelUphold.data = {
      title: this.textCopy.cancelUpholdTitle,
      includeTitle: true,
      beforeText: this.textCopy.cancelUpholdSubtitle,
      answers: [
        {
          text: "We uphold the PCN: the driver shouldn't have parked without a Pay & Display ticket, even if the ticket machine was faulty.",
          value: '0',
        },
        {
          text: "We cancel the PCN if we make checks and accept the machine was faulty. (We don't insist that drivers try another machine.)",
          value: '1',
        },
        {
          text: "We insist that drivers try another machine if there's one nearby. We cancel the PCN if we make checks and accept the machine(s) were faulty.",
          value: '2',
        },
      ],
    };
  }
  onCancelUpholdSelected(answerValue) {
    this.cancelUphold.valueSelected = answerValue;
  }

  setMachineMethodQuestion() {
    this.machineMethod.data = {
      title: this.textCopy.machineMethodTitle,
      includeTitle: true,
      beforeText: this.textCopy.machineMethodSubtitle,
      answers: [
        { text: 'check records. If inconclusive, check on-line', value: '0' },
        {
          text: "check records. If inconclusive, organise a site check of the machine if the driver's complaint arrived promptly.",
          value: '1',
        },
        { text: 'check on-line only', value: '2' },
        { text: 'check records only', value: '3' },
        { text: 'none of the above', value: '4' },
      ],
    };
  }
  onMachineMethodSelected(answerValue) {
    this.machineMethod.valueSelected = answerValue;
  }

  setFaultyMachinePolicyQuestion() {
    this.faultyMachinePolicy.data = {
      title: this.textCopy.faultyPolicyTitle,
      answers: [
        { text: "ignore other drivers' complaints", value: '0' },
        {
          text: `accept that the ticket machine was faulty if both drivers (the driver whose letter we're answering
              and the driver whose complaint is on record) had problems with the machine within a few days of each other`,
          value: '1',
        },
      ],
    };
  }
  onFaultyMachinePolicySelected(answerValue) {
    this.faultyMachinePolicy.valueSelected = answerValue;
  }

  setAcceptFaultyMachineQuestion() {
    this.acceptFaultyMachine.data = {
      title: this.textCopy.acceptMachineFaultyText,
      answers: [
        { text: 'yes', value: 'y' },
        { text: `no`, value: 'n' },
      ],
    };
  }
  onAcceptFaultyMachineSelected(answerValue) {
    this.acceptFaultyMachine.valueSelected = answerValue;
  }

  setRefundQuestion() {
    this.refund.data = {
      title: this.textCopy.refundTitle,
      includeTitle: true,
      beforeText: this.textCopy.refundSubtitle,
      answers: [
        { text: 'state the amount of money lost', value: '0' },
        { text: `state the amount of money lost and request a refund`, value: '1' },
      ],
    };
  }
  onRefundSelected(answerValue) {
    this.refund.valueSelected = answerValue;
  }

  setOtherQuestion() {
    this.other.data = {
      title: this.textCopy.otherTitle,
      includeTitle: true,
      beforeText: this.textCopy.otherSubtitle,
      answers: [
        { text: 'when they buy their ticket', value: '0' },
        { text: `when controlled hours begin`, value: '1' },
      ],
    };
  }
  onOtherSelected(answerValue) {
    this.other.valueSelected = answerValue;
  }

  setWhatPolicyQuestion() {
    this.whatPolicy.data = {
      title: this.textCopy.whatPolicyText,
      answers: [
        {
          text: `cancel the PCN if:<ul><li>the driver claims the ticket machine was faulty; and</li>
                <li>the council makes checks and accepts the machine as faulty.</li></ul>`,
          value: '0',
        },
        {
          text: `uphold the PCN and tell the driver that one or more coins were probably rejected (for being damaged or dirty)`,
          value: '1',
        },
      ],
    };
  }
  onWhatPolicySelected(answerValue) {
    this.whatPolicy.valueSelected = answerValue;
  }

  setExpiredTicketQuestion() {
    this.expiredTicket.data = {
      title: this.textCopy.expiredTicketTitle,
      answers: [
        { text: 'explain the contravention', value: '0' },
        { text: `explain the contravention and state the expiry time and PCN time`, value: '1' },
      ],
    };
  }
  onExpiredTicketSelected(answerValue) {
    this.expiredTicket.valueSelected = answerValue;
  }

  setSelectedValues() {
    this.haveTicketMachines.valueSelected = this.policiesAnswers['16_1'];
    this.cancelUphold.valueSelected = this.policiesAnswers['16_2'];
    this.machineMethod.valueSelected = this.policiesAnswers['16_3'];
    this.complaintDays = this.policiesAnswers['16_3_1'];
    this.faultyMachine = this.policiesAnswers['16_4_1'];
    this.faultyMachinePolicy.valueSelected = this.policiesAnswers['16_4_2'];
    this.fewDays = this.policiesAnswers['16_4_2_1'];
    this.acceptFaultyMachine.valueSelected = this.policiesAnswers['16_4_3'];
    this.refund.valueSelected = this.policiesAnswers['16_5'];
    this.safeguard = this.policiesAnswers['16_5_1'];
    this.other.valueSelected = this.policiesAnswers['16_6_1'];
    this.whatPolicy.valueSelected = this.policiesAnswers['16_6_2'];
    this.expiredTicket.valueSelected = this.policiesAnswers['16_6_3'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '16_1', description: this.haveTicketMachines.valueSelected },
      { id: '16_2', description: this.cancelUphold.valueSelected },
      { id: '16_3', description: this.machineMethod.valueSelected },
      { id: '16_3_1', description: this.complaintDays },
      { id: '16_4_1', description: this.faultyMachine },
      { id: '16_4_2', description: this.faultyMachinePolicy.valueSelected },
      { id: '16_4_2_1', description: this.fewDays },
      { id: '16_4_3', description: this.acceptFaultyMachine.valueSelected },
      { id: '16_5', description: this.refund.valueSelected },
      { id: '16_5_1', description: this.safeguard },
      { id: '16_6_1', description: this.other.valueSelected },
      { id: '16_6_2', description: this.whatPolicy.valueSelected },
      { id: '16_6_3', description: this.expiredTicket.valueSelected },
    ];

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
